// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulk-upload-download-button {
	height: 40px;
	padding: 0 16px;
	width: fit-content;
	border: 1px solid #1c6fd1;
	color: #1c6fd1;
	background-color: transparent;
	font-size: 15px;
	font-weight: 300;
	font-family: "PT Sans", sans-serif;
}

.bulk-upload-dnd-wrapper {
	background-color: #ffffff;
	padding: 24px;
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	gap: 16px;
	align-items: center;
	justify-content: center;
	border: 1px solid #e6e6e6;
	transition: 0.3s;
}

.bulk-upload-dnd-wrapper-active {
	background-color: #f2f2f2;
	padding: 24px;
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	gap: 16px;
	align-items: center;
	justify-content: center;
	border: 1px solid #666666;
	transition: 0.3s;
}

.bulk-upload-choose-files {
	background-color: #31b6e2;
	color: #ffffff;
	height: 40px;
	padding: 0 16px;
	border: none;
	width: fit-content;
	border-radius: 4px;
}

.bulk-upload-upload-button {
	border: 1px solid #1c6fd1;
	background-color: transparent;
	height: 40px;
	padding: 0 16px;
	color: #1c6fd1;
	width: fit-content;
	font-size: 15px;
	font-weight: 300;
	font-family: "PT Sans", sans-serif;
}

.bulk-upload-file-block {
	display: flex;
	gap: 16px;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	border: 1px solid #e6e6e6;
	padding: 10px;
	border-radius: 8px;
}

.bulk-upload-file {
	display: flex;
	align-items: center;
	gap: 8px;
}

.bulk-upload-file-info {
	display: flex;
	flex-direction: column;
}

.bulk-upload-file-delete {
	cursor: pointer;
	transition: 0.3s;
}

.bulk-upload-file-delete:hover {
	color: #191919 !important;
	transition: 0.3s;
}

.bulk-upload-file-size {
	font-size: 16px;
	line-height: 20px;
	color: #666666;
	font-weight: 400;
}

.bulk-upload-file-info-title {
	font-size: 16px;
	line-height: 20px;
	font-weight: 500;
}

.bulk-upload-errors-list {
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding-left: 16px;
}

.bulk-upload-errors-title {
	font-size: 18px;
	line-height: 24px;
	font-family: 500;
}

.bulk-upload-errors-description {
	font-size: 14px;
	line-height: 17px;
	color: #666666;
}

.bulk-upload-errors-item {
	border-left: 2px solid #ff0000;
	padding-left: 12px;
}

.bulk-upload-images-wrapper {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.bulk-upload-product-image-block {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	border: 1px solid #e6e6e6;
	border-radius: 10px;
}

.bulk-upload-product-information {
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.bulk-upload-product-information p {
	font-size: 18px;
	line-height: 23px;
	color: #191919;
	font-weight: 500;
}

.bulk-upload-product-information span {
	font-size: 14px;
	line-height: 18px;
	color: #666666;
	font-weight: 400;
}

.bulk-upload-product-information-wrapper {
	display: flex;
	gap: 16px;
	align-items: center;
	justify-content: space-between;
	padding: 8px;
	width: 100%;
}

.bulk-uploaded-product-attached-images {
	display: grid;
	grid-template-columns: repeat(8, 1fr);
	gap: 8px;
}

.bulk-uploaded-product-attached-images.attached {
	padding: 8px;
}

.bulk-uploaded-product-attached-image-block {
	width: 100px;
	position: relative;
}

.bulk-uploaded-product-attached-image-block img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 8px;
	aspect-ratio: 1 / 1;
	overflow: hidden;
}

.bulk-uploaded-product-attached-image-remove {
	display: none;
	transition: 0.3s;
}

.bulk-uploaded-product-attached-image-block:hover
	.bulk-uploaded-product-attached-image-remove {
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(0, 0, 0, 0.5);
	cursor: pointer;
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	border-radius: 8px;
	transition: 0.3s;
}

.no-product-images-block {
	display: flex;
	flex-direction: column;
	gap: 12px;
	background-color: #fceba1;
	padding: 16px;
	align-items: center;
	height: 100%;
	border-radius: 10px;
	align-items: center;
	justify-content: center;
	width: 100%;
}

.no-product-images-text {
	text-align: center;
	max-width: 500px;
	font-size: 18px;
	line-height: 22px;
}

.no-product-images-attached-list {
	display: flex;
	align-items: center;
	justify-content: start;
	flex-wrap: wrap;
	gap: 8px;
}

.bulk-origination-integration {
	font-weight: 500;
}

.bulk-origination-divider {
	position: relative;
	height: 1px;
	background-color: #e4eaee;
	width: 100%;
	margin: 12px 0;
}

.bulk-origination-divider span {
	position: absolute;
	padding: 0 12px;
	background-color: #ffffff;
	left: 50%;
	transform: translateX(-50%);
	top: -12px;
	font-size: 14px;
	font-weight: 500;
	color: #666;
}

.bulk-upload-dnd-title {
	font-size: 20px;
	line-height: 25px;
	font-weight: 400;
	color: #191919;
}
`, "",{"version":3,"sources":["webpack://./src/app/modals/BulkUpload/BulkUpload.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,yBAAyB;CACzB,cAAc;CACd,6BAA6B;CAC7B,eAAe;CACf,gBAAgB;CAChB,kCAAkC;AACnC;;AAEA;CACC,yBAAyB;CACzB,aAAa;CACb,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,mBAAmB;CACnB,uBAAuB;CACvB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,aAAa;CACb,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,mBAAmB;CACnB,uBAAuB;CACvB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd,YAAY;CACZ,eAAe;CACf,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,6BAA6B;CAC7B,YAAY;CACZ,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,kCAAkC;AACnC;;AAEA;CACC,aAAa;CACb,SAAS;CACT,mBAAmB;CACnB,8BAA8B;CAC9B,WAAW;CACX,yBAAyB;CACzB,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,8BAA8B;CAC9B,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,8BAA8B;CAC9B,WAAW;CACX,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,SAAS;CACT,mBAAmB;CACnB,8BAA8B;CAC9B,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,QAAQ;AACT;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,gBAAgB;AACjB;;AAEA;;CAEC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,oCAAoC;CACpC,eAAe;CACf,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,yBAAyB;CACzB,aAAa;CACb,mBAAmB;CACnB,YAAY;CACZ,mBAAmB;CACnB,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,sBAAsB;CACtB,eAAe;CACf,QAAQ;AACT;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,yBAAyB;CACzB,WAAW;CACX,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,yBAAyB;CACzB,SAAS;CACT,2BAA2B;CAC3B,UAAU;CACV,eAAe;CACf,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf","sourcesContent":[".bulk-upload-download-button {\n\theight: 40px;\n\tpadding: 0 16px;\n\twidth: fit-content;\n\tborder: 1px solid #1c6fd1;\n\tcolor: #1c6fd1;\n\tbackground-color: transparent;\n\tfont-size: 15px;\n\tfont-weight: 300;\n\tfont-family: \"PT Sans\", sans-serif;\n}\n\n.bulk-upload-dnd-wrapper {\n\tbackground-color: #ffffff;\n\tpadding: 24px;\n\tborder-radius: 8px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n\talign-items: center;\n\tjustify-content: center;\n\tborder: 1px solid #e6e6e6;\n\ttransition: 0.3s;\n}\n\n.bulk-upload-dnd-wrapper-active {\n\tbackground-color: #f2f2f2;\n\tpadding: 24px;\n\tborder-radius: 8px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n\talign-items: center;\n\tjustify-content: center;\n\tborder: 1px solid #666666;\n\ttransition: 0.3s;\n}\n\n.bulk-upload-choose-files {\n\tbackground-color: #31b6e2;\n\tcolor: #ffffff;\n\theight: 40px;\n\tpadding: 0 16px;\n\tborder: none;\n\twidth: fit-content;\n\tborder-radius: 4px;\n}\n\n.bulk-upload-upload-button {\n\tborder: 1px solid #1c6fd1;\n\tbackground-color: transparent;\n\theight: 40px;\n\tpadding: 0 16px;\n\tcolor: #1c6fd1;\n\twidth: fit-content;\n\tfont-size: 15px;\n\tfont-weight: 300;\n\tfont-family: \"PT Sans\", sans-serif;\n}\n\n.bulk-upload-file-block {\n\tdisplay: flex;\n\tgap: 16px;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 100%;\n\tborder: 1px solid #e6e6e6;\n\tpadding: 10px;\n\tborder-radius: 8px;\n}\n\n.bulk-upload-file {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n}\n\n.bulk-upload-file-info {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.bulk-upload-file-delete {\n\tcursor: pointer;\n\ttransition: 0.3s;\n}\n\n.bulk-upload-file-delete:hover {\n\tcolor: #191919 !important;\n\ttransition: 0.3s;\n}\n\n.bulk-upload-file-size {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #666666;\n\tfont-weight: 400;\n}\n\n.bulk-upload-file-info-title {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tfont-weight: 500;\n}\n\n.bulk-upload-errors-list {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 12px;\n\tpadding-left: 16px;\n}\n\n.bulk-upload-errors-title {\n\tfont-size: 18px;\n\tline-height: 24px;\n\tfont-family: 500;\n}\n\n.bulk-upload-errors-description {\n\tfont-size: 14px;\n\tline-height: 17px;\n\tcolor: #666666;\n}\n\n.bulk-upload-errors-item {\n\tborder-left: 2px solid #ff0000;\n\tpadding-left: 12px;\n}\n\n.bulk-upload-images-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 12px;\n}\n\n.bulk-upload-product-image-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 100%;\n\tborder: 1px solid #e6e6e6;\n\tborder-radius: 10px;\n}\n\n.bulk-upload-product-information {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 4px;\n}\n\n.bulk-upload-product-information p {\n\tfont-size: 18px;\n\tline-height: 23px;\n\tcolor: #191919;\n\tfont-weight: 500;\n}\n\n.bulk-upload-product-information span {\n\tfont-size: 14px;\n\tline-height: 18px;\n\tcolor: #666666;\n\tfont-weight: 400;\n}\n\n.bulk-upload-product-information-wrapper {\n\tdisplay: flex;\n\tgap: 16px;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 8px;\n\twidth: 100%;\n}\n\n.bulk-uploaded-product-attached-images {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(8, 1fr);\n\tgap: 8px;\n}\n\n.bulk-uploaded-product-attached-images.attached {\n\tpadding: 8px;\n}\n\n.bulk-uploaded-product-attached-image-block {\n\twidth: 100px;\n\tposition: relative;\n}\n\n.bulk-uploaded-product-attached-image-block img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n\tborder-radius: 8px;\n\taspect-ratio: 1 / 1;\n\toverflow: hidden;\n}\n\n.bulk-uploaded-product-attached-image-remove {\n\tdisplay: none;\n\ttransition: 0.3s;\n}\n\n.bulk-uploaded-product-attached-image-block:hover\n\t.bulk-uploaded-product-attached-image-remove {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: rgba(0, 0, 0, 0.5);\n\tcursor: pointer;\n\twidth: 100%;\n\theight: 100%;\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tborder-radius: 8px;\n\ttransition: 0.3s;\n}\n\n.no-product-images-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 12px;\n\tbackground-color: #fceba1;\n\tpadding: 16px;\n\talign-items: center;\n\theight: 100%;\n\tborder-radius: 10px;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 100%;\n}\n\n.no-product-images-text {\n\ttext-align: center;\n\tmax-width: 500px;\n\tfont-size: 18px;\n\tline-height: 22px;\n}\n\n.no-product-images-attached-list {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: start;\n\tflex-wrap: wrap;\n\tgap: 8px;\n}\n\n.bulk-origination-integration {\n\tfont-weight: 500;\n}\n\n.bulk-origination-divider {\n\tposition: relative;\n\theight: 1px;\n\tbackground-color: #e4eaee;\n\twidth: 100%;\n\tmargin: 12px 0;\n}\n\n.bulk-origination-divider span {\n\tposition: absolute;\n\tpadding: 0 12px;\n\tbackground-color: #ffffff;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\ttop: -12px;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tcolor: #666;\n}\n\n.bulk-upload-dnd-title {\n\tfont-size: 20px;\n\tline-height: 25px;\n\tfont-weight: 400;\n\tcolor: #191919;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
